import { render, staticRenderFns } from "./deposit-form.vue?vue&type=template&id=4d61109c&"
import script from "./deposit-form.vue?vue&type=script&lang=js&"
export * from "./deposit-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports